import { Link } from 'react-router-dom';
import { services } from '../../data/mock';
import { CityOverview } from '../home/CityOverview';
import { CityServices } from '../home/CityServices';
import { ServiceLinks } from './ServiceLinks';

export const RestoredPageContent = ({ page }) => {
  const service = services.find(({ id }) => id === page.serviceId);
  return (
    <article data-testid="restored-page-content" className="restored-content">
      {page.kind === 'city' ? (
        <>
          <CityOverview city={page.city} />
          <CityServices city={page.city} />
        </>
      ) : (
        <>
          <h2 data-testid="restored-service-title">{service.title}</h2>
          <p data-testid="restored-service-description">{service.description}</p>
          {page.city && <CityServices city={page.city} />}
        </>
      )}
      <ServiceLinks />
      {page.city && (
        <p>
          <a data-testid="restored-city-home-section" href="/#villes">Intervention dans toute la Guadeloupe</a>
        </p>
      )}
      {page.city === 'Lamentin' && page.kind === 'city' && (
        <p><Link data-testid="lamentin-article-link" to="/blog/desenvoutement-lamentin-guadeloupe">Désenvoûtement à Lamentin</Link></p>
      )}
    </article>
  );
};